import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { EmailSourceEntity } from './email-source.entity';

export enum EmailSyncJobStatus {
	PENDING = 'pending',
	PROCESSING = 'processing',
	COMPLETED = 'completed',
	FAILED = 'failed',
}

export enum EmailSyncJobType {
	FULL_SYNC = 'full_sync',
	FOLDER_SYNC = 'folder_sync',
	DELTA_SYNC = 'delta_sync',
}

@Entity('email_sync_job')
@Index(['emailSourceId', 'status'])
@Index(['createdDate'])
export class EmailSyncJobEntity extends BaseEntity {
	@Column({ name: 'fk_email_source__id', type: 'int', unsigned: true })
	public emailSourceId!: number;

	@ManyToOne(() => EmailSourceEntity)
	@JoinColumn({ name: 'fk_email_source__id' })
	public emailSource!: EmailSourceEntity;

	@Column({
		type: 'enum',
		enum: EmailSyncJobType,
	})
	public type!: EmailSyncJobType;

	@Column({
		type: 'enum',
		enum: EmailSyncJobStatus,
		default: `'${EmailSyncJobStatus.PENDING}'`,
	})
	public status!: EmailSyncJobStatus;

	@Column({ name: 'total_folders', type: 'int', default: 0 })
	public totalFolders!: number;

	@Column({ name: 'completed_folders', type: 'int', default: 0 })
	public completedFolders!: number;

	@Column({ name: 'total_messages', type: 'int', default: 0 })
	public totalMessages!: number;

	@Column({ name: 'completed_messages', type: 'int', default: 0 })
	public completedMessages!: number;

	@Column({ name: 'child_job_ids', type: 'json', nullable: true })
	public childJobIds?: string[];

	@Column({ name: 'started_at', type: 'timestamp', nullable: true })
	public startedAt?: Date;

	@Column({ name: 'completed_at', type: 'timestamp', nullable: true })
	public completedAt?: Date;

	@Column({ type: 'text', nullable: true })
	public error?: string;

	@Column({ name: 'error_details', type: 'json', nullable: true })
	public errorDetails?: any;

	@Column({ name: 'target_folder_ids', type: 'json', nullable: true })
	public targetFolderIds?: Array<string>;
}
